// extracted by mini-css-extract-plugin
export default {"container":"xnlxIwTTSJD9T_OGe7gw","bmrUnit":"s4MLvA0yzGJ94hbxmFk9"};